import * as Matomo from '@easybell/matomo-tracking'
import { debounce } from 'lodash'

const siteId = '4'

export function trackPageView() {
  Matomo.trackPageView(siteId, 'CTA')
}

export function matomoInit() {
  Matomo.addScript(siteId)
  track('appInit')
}

export function trackEvent(
  category: string,
  action: string,
  name?: string,
  value?: number | string
) {
  Matomo.push([
    'trackEvent',
    category,
    action,
    ...(name !== undefined
      ? [name, ...(value !== undefined ? [value] : [])]
      : []),
  ])
}

const debouncedEvents: Record<string, () => void> = {}

export function trackEventDebounced(
  category: string,
  action: string,
  name?: string,
  value?: number | string
) {
  const key = [category, action, name, value].join('-')

  const debouncedEvent = debouncedEvents[key]

  if (debouncedEvent) {
    debouncedEvent()
  } else {
    const newDebouncedEvent = debounce(
      () => trackEvent(category, action, name, value),
      1_000
    )

    debouncedEvents[key] = newDebouncedEvent
    newDebouncedEvent()
  }
}

export function trackLink(url: string) {
  Matomo.push(['trackLink', url, 'link'])
}

type TelemetryPoint = 'appInit' | 'pageView' | 'overviewMounted'

const telemetry: Partial<Record<TelemetryPoint, number>> = {}

export function track(type: TelemetryPoint) {
  telemetry[type] = performance.now()
}

function getIndicator(type: TelemetryPoint) {
  return telemetry[type]
}

function msToSeconds(value: number) {
  return value / 1000
}

export function getDistance(from: TelemetryPoint, to: TelemetryPoint) {
  const indicatorTo = getIndicator(to)

  const indicatorFrom = getIndicator(from)

  if (indicatorFrom && indicatorTo) {
    return msToSeconds(indicatorTo - indicatorFrom)
  }
}
